import { Routes, Route, Navigate } from "react-router-dom";
import { PageLink, PageTitle } from "../../../_metronic/layout/core";
import { ListExtctractor } from "./components/ListExtctractor";
import { FormExtractor } from "./components/FormExtractor";

const breadcrumbs: Array<PageLink> = [
  {
    title: 'Arteco Admin GUI',
    path: '',
    isSeparator: false,
    isActive: false,
    disableLink: true,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const breadcrumbs_with_lista: Array<PageLink> = [
  {
    title: 'Arteco Admin GUI',
    path: '',
    isSeparator: false,
    isActive: false,
    disableLink: true,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Lista Estrattori',
    path: '/extractors',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];



export const ExtractorsRoutes = () => (
  <Routes>
    <Route
      index
      element={
        <>
          <PageTitle breadcrumbs={breadcrumbs}>Lista Estrattori</PageTitle>
          <ListExtctractor />
        </>
      }
    />
    <Route
          path='add'
          element={
            <>
              <PageTitle breadcrumbs={breadcrumbs_with_lista}>Nuovo estrattore</PageTitle>
              <FormExtractor />
            </>
          }
        />
    <Route
          path='edit/:id'
          element={
            <>
              <PageTitle breadcrumbs={breadcrumbs_with_lista}>Modifica estrattore</PageTitle>
              <FormExtractor />
            </>
          }
        />
        <Route path='*' element={<Navigate to='/error/404' />} />
  </Routes>
)
